import {createFileRoute} from '@tanstack/react-router';

import DisableEmails from '@/public/views/DisableEmails';

export const Route = createFileRoute('/(public)/disable-emails/$token')({
  component: DisableEmails,
  loader: ({params}) => ({
    token: params.token
  })
});
